export default "__VITE_ASSET__Ej2MrZ_c__"